let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("547YV")).then(() => parcelRequire('ibOo1'));